<template>
	<slot />
</template>
